export enum TransactionStatus {
  Intent = 'INTENT',
  PendingCustomerSignature = 'PENDING_CUSTOMER_SIGNATURE',
  InReview = 'IN_REVIEW',
  Declined = 'DECLINED',
  Approved = 'APPROVED',
  AwaitingFirstClose = 'AWAITING_FIRST_CLOSE',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Invested = 'INVESTED',
}

export interface PaymentDetails {
  accountHolderName: string;
  bankLocation: string;
  bankName: string;
  iban: string;
  bankAccountNumber: string;
  swiftOrBic: string;
}

export interface PaymentDetailsData {
  amount: number;
  date: Date;
  originatorDetails: PaymentDetails;
  receiverDetails: PaymentDetails;
}

export interface UserTransaction {
  id: string;
  productName: string;
  type: string;
  subscriptionDate: string;
  investmentDate: string;
  status: TransactionStatus;
  amount: number;
  currency: string;
  paymentDetails?: PaymentDetailsData;
}
